module.exports = __webpack_public_path__ + "img/marker-oil-produce-full.411f85bb.png";